


























































import { Component, Vue, Prop } from 'vue-property-decorator';
import DynamicImageIcon from '@/components/icons/DynamicImageIcon.vue';
@Component({
  components: {
    DynamicImageIcon
  }
})
export default class LogoCarousel extends Vue {
  @Prop() items!:any[];
}
